var _link, _solid, _minimal, _link2, _solid2, _minimal2, _link3, _solid3, _minimal3, _link4, _solid4, _minimal4, _link5, _solid5, _minimal5, _link6, _solid6, _minimal6, _link7, _solid7, _minimal7, _link8, _solid8, _minimal8, _link9, _solid9, _minimal9, _link10, _solid10, _minimal10, _link11;

import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { fontWeight, radius, themeMode, variant, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var activeState = '&:is(:hover, [aria-expanded="true"], [aria-checked="true"], [aria-current="true"])';
var sizeStyles = variant({
  prop: "size",
  variants: {
    xs: {
      fontSize: "sm",
      lineHeight: 1.23,
      height: "24px",
      minWidth: "24px",
      px: "sm"
    },
    sm: {
      fontSize: "md",
      lineHeight: 1.33,
      height: "36px",
      minWidth: "36px",
      px: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: 1.6,
      height: "48px",
      minWidth: "48px",
      px: "md"
    },
    lg: {
      fontSize: "lg",
      lineHeight: 1.6,
      height: "64px",
      minWidth: "64px",
      px: "lg"
    }
  }
});
var iconSizeStyles = variant({
  prop: "size",
  variants: {
    xs: {
      marginRight: "4px",
      marginLeft: "-4px"
    },
    sm: {
      marginRight: "4px",
      marginLeft: "-4px"
    },
    md: {
      marginRight: "8px",
      marginLeft: "-4px"
    },
    lg: {
      marginRight: "8px",
      marginLeft: "-4px"
    }
  }
});
var iconRightSizeStyles = variant({
  prop: "size",
  variants: {
    xs: {
      marginRight: "-4px",
      marginLeft: "4px"
    },
    sm: {
      marginRight: "-4px",
      marginLeft: "4px"
    },
    md: {
      marginRight: "-8px",
      marginLeft: "4px"
    },
    lg: {
      marginRight: "-8px",
      marginLeft: "4px"
    }
  }
});
var kindStyles = variant({
  prop: "kind",
  variants: {
    solid: {
      '&[aria-disabled="true"]': {
        color: themeMode({
          light: "neutral.400",
          dark: "neutral.600"
        }),
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      }
    },
    minimal: {
      backgroundColor: "transparent",
      '&[aria-disabled="true"]': {
        color: themeMode({
          light: "neutral.400",
          dark: "neutral.600"
        })
      }
    },
    link: (_link = {
      backgroundColor: "transparent",
      border: "none",
      height: "initial",
      minWidth: "initial",
      padding: 0
    }, _link[activeState] = {
      textDecoration: "underline"
    }, _link['&[aria-disabled="true"]'] = {
      color: themeMode({
        light: "neutral.400",
        dark: "neutral.500"
      })
    }, _link)
  }
});
var variantKindStyles = variant({
  prop: "variant",
  compoundProp: "kind",
  variants: {
    primary: {
      solid: (_solid = {
        color: "neutral.900",
        backgroundColor: "primary.500"
      }, _solid[activeState] = {
        backgroundColor: "primary.700"
      }, _solid),
      minimal: (_minimal = {
        color: "primary.500"
      }, _minimal[activeState] = {
        color: "neutral.50",
        backgroundColor: "primary.700"
      }, _minimal),
      link: (_link2 = {
        color: "primary.500"
      }, _link2[activeState] = {
        color: "primary.700"
      }, _link2)
    },
    secondary: {
      solid: (_solid2 = {
        color: themeMode({
          light: "neutral.50",
          dark: "neutral.1000"
        }),
        backgroundColor: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }, _solid2[activeState] = {
        backgroundColor: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }, _solid2),
      minimal: (_minimal2 = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }, _minimal2[activeState] = {
        color: themeMode({
          light: "neutral.50",
          dark: "neutral.1000"
        }),
        backgroundColor: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }, _minimal2),
      link: (_link3 = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }, _link3[activeState] = {
        color: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }, _link3)
    },
    danger: {
      solid: (_solid3 = {
        color: "neutral.50",
        backgroundColor: "danger.500"
      }, _solid3[activeState] = {
        backgroundColor: "danger.700"
      }, _solid3),
      minimal: (_minimal3 = {
        color: "danger.500"
      }, _minimal3[activeState] = {
        color: "neutral.50",
        backgroundColor: "danger.700"
      }, _minimal3),
      link: (_link4 = {
        color: "danger.500"
      }, _link4[activeState] = {
        color: "danger.700"
      }, _link4)
    },
    warning: {
      solid: (_solid4 = {
        color: "neutral.900",
        backgroundColor: "warning.500"
      }, _solid4[activeState] = {
        backgroundColor: "warning.700"
      }, _solid4),
      minimal: (_minimal4 = {
        color: "warning.500"
      }, _minimal4[activeState] = {
        color: "neutral.50",
        backgroundColor: "warning.700"
      }, _minimal4),
      link: (_link5 = {
        color: "warning.500"
      }, _link5[activeState] = {
        color: "warning.700"
      }, _link5)
    },
    success: {
      solid: (_solid5 = {
        color: "neutral.50",
        backgroundColor: "success.500"
      }, _solid5[activeState] = {
        backgroundColor: "success.700"
      }, _solid5),
      minimal: (_minimal5 = {
        color: "success.500"
      }, _minimal5[activeState] = {
        color: "neutral.50",
        backgroundColor: "success.700"
      }, _minimal5),
      link: (_link6 = {
        color: "success.500"
      }, _link6[activeState] = {
        color: "success.700"
      }, _link6)
    },
    subtle: {
      solid: (_solid6 = {
        color: themeMode({
          light: "neutral.1000",
          dark: "neutral.50"
        }),
        backgroundColor: themeMode({
          light: "neutral.0",
          dark: "neutral.1000"
        })
      }, _solid6[activeState] = {
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      }, _solid6),
      minimal: (_minimal6 = {
        color: themeMode({
          light: "neutral.1000",
          dark: "neutral.50"
        })
      }, _minimal6[activeState] = {
        backgroundColor: themeMode({
          light: "neutral.0",
          dark: "neutral.1000"
        })
      }, _minimal6),
      link: (_link7 = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }, _link7[activeState] = {
        color: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }, _link7)
    },
    accent: {
      solid: (_solid7 = {
        color: "neutral.50",
        backgroundColor: "secondary.500"
      }, _solid7[activeState] = {
        backgroundColor: "secondary.700"
      }, _solid7),
      minimal: (_minimal7 = {
        color: "secondary.500"
      }, _minimal7[activeState] = {
        color: "neutral.50",
        backgroundColor: "secondary.700"
      }, _minimal7),
      link: (_link8 = {
        color: "secondary.500"
      }, _link8[activeState] = {
        color: "secondary.700"
      }, _link8)
    },
    ghost: {
      solid: (_solid8 = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      }, _solid8[activeState] = {
        backgroundColor: themeMode({
          light: "neutral.300",
          dark: "neutral.600"
        })
      }, _solid8),
      minimal: (_minimal8 = {
        color: themeMode({
          light: "neutral.500",
          dark: "neutral.400"
        })
      }, _minimal8[activeState] = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        backgroundColor: themeMode({
          light: "neutral.300",
          dark: "neutral.600"
        })
      }, _minimal8),
      link: (_link9 = {
        color: themeMode({
          light: "neutral.500",
          dark: "neutral.400"
        })
      }, _link9[activeState] = {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }, _link9)
    },
    facebook: {
      solid: (_solid9 = {
        color: "neutral.50",
        backgroundColor: "facebook.500"
      }, _solid9[activeState] = {
        backgroundColor: "facebook.700"
      }, _solid9),
      minimal: (_minimal9 = {
        color: "facebook.500"
      }, _minimal9[activeState] = {
        color: "neutral.50",
        backgroundColor: "facebook.700"
      }, _minimal9),
      link: (_link10 = {
        color: "facebook.500"
      }, _link10[activeState] = {
        color: "facebook.700"
      }, _link10)
    },
    twitter: {
      solid: (_solid10 = {
        color: "neutral.50",
        backgroundColor: "twitter.500"
      }, _solid10[activeState] = {
        backgroundColor: "twitter.700"
      }, _solid10),
      minimal: (_minimal10 = {
        color: "twitter.500"
      }, _minimal10[activeState] = {
        color: "neutral.50",
        backgroundColor: "twitter.700"
      }, _minimal10),
      link: (_link11 = {
        color: "twitter.500"
      }, _link11[activeState] = {
        color: "twitter.700"
      }, _link11)
    }
  }
});
var ButtonText = styled(Box).attrs(function () {
  return {
    as: "span"
  };
}).withConfig({
  componentId: "ef8j7g-0"
})([""]);
ButtonText.displayName = "Styled.ButtonText";
var ButtonLoader = styled(Box).withConfig({
  componentId: "ef8j7g-1"
})(function (_ref) {
  var state = _ref.state;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    verticalAlign: "middle",
    transition: "opacity 300ms ease-in-out",
    opacity: state === "entered" ? 1 : 0,
    transform: "translate3d(0, 0, 0)",
    svg: {
      width: "1em",
      height: "1em"
    }
  };
});
ButtonLoader.displayName = "Button.Loader";
var ButtonIcon = styled(Box).withConfig({
  componentId: "ef8j7g-2"
})([""]);
ButtonIcon.displayName = "Button.Icon";
var ButtonIconRight = styled(Box).withConfig({
  componentId: "ef8j7g-3"
})([""]);
ButtonIconRight.displayName = "Button.IconRight";
var Button = styled(Box).withConfig({
  componentId: "ef8j7g-4"
})(["appearance:none;display:", ";flex-direction:row;justify-content:", ";align-items:center;position:relative;min-width:5ch;width:", ";border:none;text-align:center;vertical-align:middle;white-space:nowrap;text-decoration:none;font-weight:", ";padding:0;text-decoration:none;background-color:transparent;user-select:none;transition:all 300ms ease-in-out;border-radius:", ";", ";", ";", ";&[aria-pressed='true'],&:hover{cursor:pointer;}&:disabled,&[aria-disabled='true']{cursor:default;pointer-events:none;}&:focus,&:active{outline:none;}&:focus-visible{box-shadow:", " 0px 0px 0px 2px;}", "{display:flex;transition:opacity 300ms ease-in-out;opacity:", ";}", ",", "{transition:opacity 300ms ease-in-out;opacity:", ";}", "{", ";}", "{", ";}"], function (_ref2) {
  var isFull = _ref2.isFull;
  return isFull ? "flex" : "inline-flex";
}, function (_ref3) {
  var isDropdown = _ref3.isDropdown;
  return isDropdown ? "space-between" : "center";
}, function (_ref4) {
  var isFull = _ref4.isFull;
  return isFull ? "100%" : "auto";
}, fontWeight("bold"), function (_ref5) {
  var shape = _ref5.shape;
  return shape === "rounded" ? radius("round") : radius("sm");
}, sizeStyles, kindStyles, variantKindStyles, themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}), ButtonText, function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading ? 0 : 1;
}, ButtonIcon, ButtonIconRight, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading ? 0 : 1;
}, ButtonIcon, iconSizeStyles, ButtonIconRight, iconRightSizeStyles);
Button.displayName = "Styled.Button";
export { Button, ButtonIcon, ButtonIconRight, ButtonLoader, ButtonText };